import { useQuery } from '@tanstack/react-query'
import { fetchDosageForms } from 'utils/api/product'

export function useDosageForms() {
  const query = useQuery(['dosage-forms'], fetchDosageForms)

  return query
}
